import type { CoreServiceTypeDetails, CoreServiceTypeDetailsDTO } from 'api/coreServiceTypes/types';
import parseDynamicTranslatableName from 'services/parseDynamicTranslatableName/parseDynamicTranslatableName';

export const parseServiceTypeDetailsForFE = (rawData: CoreServiceTypeDetailsDTO): CoreServiceTypeDetails => ({
  id: rawData.id,
  name: parseDynamicTranslatableName(rawData.name),
  serviceOrigin: rawData.service_origin,
  ordering: rawData.ordering,
});
